module.exports = __webpack_public_path__ + "img/ori_img_1.cc74462f.jpeg";